export function filterAllowedRoutes(section, userPrivileges) {
  if (!section || !section.children) return null;

  const canAccessRoute = (route) => {
    if (route.privilege) {
      return userPrivileges.includes(route.privilege);
    }

    if (Array.isArray(route.privileges) && route.privileges.length > 0) {
      if (route.all) {
        return route.privileges.every((p) => userPrivileges.includes(p));
      }
      return route.privileges.some((p) => userPrivileges.includes(p));
    }

    return true;
  };

  const filterRoute = (route) => {
    if (!canAccessRoute(route)) return null;

    if (!route.children) {
      return route;
    }

    const filteredChildren = route.children
      .map(filterRoute)
      .filter(Boolean);

    if (filteredChildren.length === 0) {
      return null;
    }

    return {
      ...route,
      children: filteredChildren,
    };
  };

  const allowedChildren = section.children
    .map(filterRoute)
    .filter(Boolean);

  if (allowedChildren.length === 0) {
    return null;
  }

  return {
    ...section,
    children: allowedChildren,
  };
}
